module.exports = __webpack_public_path__ + "static/media/no-video.dbbb08f2.svg";